import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setCsrf } from "./api";

const AuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  // null = checking, false = unauthenticated, object = authenticated
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const me = await api.me();
      setCsrf(me.csrf_token);
      setUser(me);
      return me;
    } catch (e) {
      setCsrf(null);
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const data = await api.login(email, password);
    setCsrf(data.csrf_token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.logout();
    } catch (_) {
      /* ignore */
    }
    setCsrf(null);
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
};
